var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"empty-image",attrs:{"src":_vm.emptyImage}}),_c('h6',{staticClass:"text-center"},[_vm._v("\n        "+_vm._s(_vm.caption)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }